import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './timeline-pagination.scss';

class TimelinePagination extends Component {
	constructor(props) {
		super(props);

		this.pagerElement = React.createRef();
		this.currentOffset = 0;
	}

	getWidth = () => {
		const indicator = this.pagerElement.current.querySelector('.slider-timeline-pager__indicator');
		return indicator.getBoundingClientRect().width;
	}

	render() {
		const { paginations, swiperIndex, speed } = this.props;

		if (swiperIndex === 0) {
			this.currentOffset = 0;
		}

		/* Sets the current offset amount based on the current index (swiperIndex). Starting
		 * once the index reaches the third pagination item (swiperIndex = 2), by multiplying
		 * the column width by the current index, minus 2.
		 */
		if (swiperIndex > 1 && swiperIndex < (paginations.length - 2)) {
			this.currentOffset = this.getWidth() * (swiperIndex - 2);
		}

		// makes sure the last indicator is in view when click on the second to last indicator and pressing the forward arrow.
		if (swiperIndex === (paginations.length - 2)) {
			this.currentOffset = this.getWidth() * (swiperIndex - 3);
		}

		return (
			<div className="slider-timeline-pager__inner" ref={this.pagerElement} style={{ transform: `translateX(-${this.currentOffset}px)`, transitionDuration: `${speed}ms` }}>
				{paginations.map((pagination) => {
					return (
						<span key={pagination.id} className={`slider-timeline-pager__indicator${pagination.active ? ' is-active' : ''}`} role="presentation" onClick={() => { if (pagination.onClick) pagination.onClick(pagination.id); }}>
							<span className="slider-timeline-pager__indicator-wrapper">
								{pagination.year}
							</span>
						</span>
					);
				})}
			</div>
		);
	}
}

TimelinePagination.defaultProps = {
	paginations: [],
};

TimelinePagination.propTypes = {
	paginations: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		year: PropTypes.string.isRequired,
		active: PropTypes.bool,
		onClick: PropTypes.func,
	})),
	swiperIndex: PropTypes.number.isRequired,
	speed: PropTypes.number.isRequired,
};

export default TimelinePagination;
